import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import configMenu from '../configMenu.vue';
import draggable from 'vuedraggable';
import { getPictureByKey } from '@/views/custom-layout/api';
import { isEmpty, guid } from '@/utils';
export default {
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary,
    configMenu: configMenu,
    draggable: draggable
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    customerPackageList: Array,
    systemMenus: Object,
    tabListFlat: Array,
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    parentKey: String
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureList: [],
      depot: {},
      updateIndex: 0
    };
  },
  methods: {
    addMenu: function addMenu() {
      this.value.config.value.push({
        flag: true,
        type: 'other',
        imageurl: '',
        name: '',
        link_type: '1',
        link_value: '',
        goods_id: '',
        module_plate_id: '',
        uid: guid()
      });
    },
    onDelete: function onDelete(index) {
      var _this = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this.value.config.value.splice(index, 1);
      }).catch(function () {});
    },
    checkFlag: function checkFlag(rule, value, callback) {
      var showTabs = this.value.config.value.filter(function (i) {
        return i.flag;
      });
      if (showTabs.length < 1) {
        callback('至少开启一项配置');
      } else {
        callback();
      }
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this2 = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this2.pictureList = picture[1] || [];
        _this2.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      if (typeof this.updateIndex === 'number') {
        this.value.config.value[this.updateIndex]['imageurl'] = path;
      } else {
        this.value.config.imageurl = path;
      }
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(index) {
      if (typeof index === 'number') {
        this.$refs.uploadBanner[index].uploadBanner();
      } else {
        this.$refs[index].uploadBanner();
      }
    },
    emitUploadFile: function emitUploadFile(res, item) {
      item.imageurl = "".concat(this.$ossurl).concat(res);
    }
  },
  created: function created() {
    var _this3 = this;
    var _this$value$config = this.value.config,
      _this$value$config$sh = _this$value$config.show_style,
      show_style = _this$value$config$sh === void 0 ? 1 : _this$value$config$sh,
      _this$value$config$im = _this$value$config.imageurl,
      imageurl = _this$value$config$im === void 0 ? 'https://res.youlianfuwu.com/mini_program/more.png' : _this$value$config$im,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_,
      _this$value$config$va = _this$value$config.value,
      value = _this$value$config$va === void 0 ? [] : _this$value$config$va;
    value = value.length > 0 ? value : Array.from({
      length: 4
    }, function (_, index) {
      return _objectSpread({
        flag: true,
        imageurl: {
          0: 'https://res.youlianfuwu.com/mini_program/charge.png',
          1: 'https://res.youlianfuwu.com/mini_program/onlinecs.png',
          2: 'https://res.youlianfuwu.com/mini_program/phonecs.png',
          3: 'https://res.youlianfuwu.com/mini_program/bindcard.png'
        }[index],
        name: {
          0: '切换企业',
          1: '在线客服',
          2: '电话客服',
          3: '扫码绑卡'
        }[index]
      }, index === 0 ? {
        type: 'switch_account',
        account_sort: 1
      } : {
        type: 'other',
        link_type: '7',
        link_value: {
          1: 'online_service',
          2: 'tel_service',
          3: 'scan'
        }[index],
        goods_id: '',
        module_plate_id: ''
      });
    });
    if (isEmpty(this.value.config_default_value)) {
      var defaultConfig = this.tabListFlat.find(function (i) {
        return i.key === _this3.value.key;
      });
      this.$set(this.value, 'config_default_value', JSON.parse(JSON.stringify(defaultConfig.config_default_value)));
    }
    this.$set(this.value, 'config', {
      show_style: show_style,
      imageurl: imageurl,
      margin_top: margin_top,
      z_index: z_index,
      value: value.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          uid: guid()
        });
      })
    });
    this.getPicture();
  },
  computed: {
    showDelete: function showDelete() {
      var list = this.value.config.value.filter(function (i) {
        return i.type !== 'switch_account';
      });
      return list.length > 1;
    }
  }
};